// extracted by mini-css-extract-plugin
export default {"hr":"hr-module___hr___d998326e","noMargin":"hr-module___noMargin___d19b6e9b"};